import type { TRegionStyleColors, TAlphaRegionsChannel } from './types';

const style = window.getComputedStyle(document.body);

export const ALPHA = {
  unhovered: 0.25,
  hovered: 0.15,
} as const;

const setAlphaChannelInColor = (color: TRegionStyleColors, alphaChannel: TAlphaRegionsChannel) => {
  return `rgb(from ${style.getPropertyValue(color)} r g b / ${alphaChannel})`;
};

export const CANVAS_COLORS = {
  positive: {
    base: style.getPropertyValue('--color-positive-variant'),
    unhovered: setAlphaChannelInColor('--color-positive-variant', ALPHA.unhovered),
    hovered: setAlphaChannelInColor('--color-positive-variant', ALPHA.hovered),
  },
  accentOrange: {
    base: style.getPropertyValue('--color-accent-orange'),
    unhovered: setAlphaChannelInColor('--color-accent-orange', ALPHA.unhovered),
    hovered: setAlphaChannelInColor('--color-accent-orange', ALPHA.hovered),
  },
  accentBlue: {
    base: style.getPropertyValue('--color-accent-blue'),
    unhovered: setAlphaChannelInColor('--color-accent-blue', ALPHA.unhovered),
    hovered: setAlphaChannelInColor('--color-accent-blue', ALPHA.hovered),
  },
  accentRed: {
    base: style.getPropertyValue('--color-accent-red'),
    unhovered: setAlphaChannelInColor('--color-accent-red', ALPHA.unhovered),
    hovered: setAlphaChannelInColor('--color-accent-red', ALPHA.hovered),
  },
  alwaysBlack: {
    base: style.getPropertyValue('--color-always-black'),
    unhovered: setAlphaChannelInColor('--color-always-black', ALPHA.unhovered),
    hovered: setAlphaChannelInColor('--color-always-black', ALPHA.hovered),
  },
} as const;

export const DEFAULT_COLOR = CANVAS_COLORS.positive.base;

export const getRandomColor = () => {
  const colorsList = Object.keys(CANVAS_COLORS);
  return colorsList[Math.floor(Math.random() * colorsList.length)];
};
